export default {
  playBtn: '开始播放粒子特效',
  stopBtn: '暂停播放粒子特效',
}
